import {
  useWSModalCustom,
  WSCard,
  WSList,
  WSModal,
  WSModalCustomProps
} from "@wingspanhq/fe-component-library";
import {
  InsuranceCoverage,
  InsuranceMonitor
} from "@wingspanhq/wingspan-api-sdk";

import { DataViewGrid } from "../../../../../shared/components/DataView";
import { AIValidationWidget } from "../../../components/AIValidationWidget";
import { RequirementContextType } from "../../../types";
import { getInsuranceMonitorValidationItems } from "../configs/helpers/getInsuranceMonitorValidationItems";
import { selectorIsFullMatch } from "../selectors/selectorIsFullMatch";

type Props = WSModalCustomProps<void> & {
  item: InsuranceCoverage;
  coverageMonitor: InsuranceMonitor;
};

export const ModalValidationDetails: React.FC<Props> = props => {
  const validationItems = getInsuranceMonitorValidationItems(
    props.coverageMonitor
  );
  const isFullMatch = selectorIsFullMatch(props.coverageMonitor);

  return (
    <WSModal
      actions={{
        alignment: "fill",
        buttons: [
          {
            label: "Done",
            onClick: () => {
              props.onClose();
            }
          }
        ]
      }}
      title="Verification details"
      {...props}
    >
      <WSList gap="XL">
        {/* Header card */}
        <WSCard>
          <DataViewGrid
            data={[
              {
                label: "Policy",
                value: props.item.policyNumber || props.item.carrier
              },
              {
                label: "Matching Results",
                pill: {
                  theme: isFullMatch ? "success" : "warning",
                  icon: true,
                  text: isFullMatch ? "Passed" : "Partial match"
                },
                value: null,
                hideValue: true
              }
            ]}
            gridColumns={2}
          />
        </WSCard>
        <AIValidationWidget
          contextType={RequirementContextType.Payee}
          validationItems={validationItems}
        />
      </WSList>
    </WSModal>
  );
};

export const useModalValidationDetails = () =>
  useWSModalCustom(ModalValidationDetails);
